































































import {translate} from '@/services/trans'
import {getMargin} from "@/services/margin";
import {Component, Emit, Prop, Vue} from "vue-property-decorator";

@Component
export default class HotspotBauminator extends Vue {
  @Prop() isMobileView!: boolean;
  public margin: number = 0;
  public c_y: number = 0;
  public hotspotSelected: any = null;
  public hotspotBg: string = !this.isMobileView ? require('@/assets/images/tooltip-bg.png') : require('@/assets/images/tooltip_bg_mobile.png');
  public hotspots :any= [];
  public hotspotData = [
    {
      x: 435,//315,
      y: 220,//112,
      title: '',
      content: '',
      title_key: 'hotspot_0_title',
      content_key: 'hotspot_0_content',
    },
    {
      x: 810,//315,
      y: 240,//112,
      title: '',
      content: '',
      title_key: 'hotspot_1_title',
      content_key: 'hotspot_1_content',
    },
    {
      x: 600,//210,
      y: 375,//247,
      title: '',
      content: '',
      title_key: 'hotspot_2_title',
      content_key: 'hotspot_2_content',
    },
    {
      x: 325,//473,
      y: 480,//260,
      title: '',
      content: '',
      title_key: 'hotspot_3_title',
      content_key: 'hotspot_3_content',
    },
    {
      x: 95,
      y: 762,
      title: '',
      content: '',
      title_key: 'hotspot_6_title',
      content_key: 'hotspot_6_content',
    },
    {
      x: 800,
      y: 790,
      title: '',
      content: '',
      title_key: 'hotspot_7_title',
      content_key: 'hotspot_7_content',
    },
    {
      x: 155,
      y: 105,
      title: '',
      content: '',
      title_key: 'hotspot_team_title',
      content_key: 'hotspot_team_content',
    },
  ]

  mounted() {
    let hotspot = null;
    for (let index in this.hotspotData) {
      hotspot = this.hotspotData[index];
      hotspot.title = translate(hotspot.title_key);
      hotspot.content = translate(hotspot.content_key);
    }
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onResize);
    window.addEventListener('scroll', this.onScroll);

    setTimeout(() => {
      this.setMargin()
    }, 1000);
  }

  onResize() {
    this.hotspots = [];
    let hotspot = null;
    let hotspotBackgroundWidth = 978;
    //@ts-ignore
    // hotspotBackgroundWidth = document.getElementById("baumit-hotspot").width;
    let hotspotBackground :any= document.getElementById("baumit-hotspot");
    let sizeScale = hotspotBackground.clientWidth / hotspotBackgroundWidth;
    for (let index in this.hotspotData) {
      hotspot = JSON.parse(JSON.stringify(this.hotspotData[index]));
      hotspot.x = hotspot.x * sizeScale;
      hotspot.y = hotspot.y * sizeScale;
      this.hotspots.push(hotspot);
    }

    this.setMargin();
  }
  onScroll(e:any) {
    const element:any = document.getElementById('bauminatorHotspotContainer')
    const elementTopPosition = element.getBoundingClientRect().top
    const elementInnerHeight = element.clientHeight
    const pageYOffset = window.pageYOffset
    const innerHeight = window.innerHeight
    this.c_y = (elementTopPosition / (elementInnerHeight / 100)) * 1.8

    if(this.c_y < -50 && this.downAction){
      this.nextFrom('bauminatorHotspotContainer', false)
      this.downAction = false
      this.upAction = true
    }
    if(this.c_y > -20 && this.upAction){
      this.nextFrom('bauminatorHotspotContainer', true)
      this.downAction = true
      this.upAction = false
    }

    this.setMargin();
  }


  upAction = false
  downAction = true

  hotspotBackgroundLoaded() {
    this.onResize();
  }


  setMargin() {
    this.margin = getMargin('hotspotInner')
  }

  setHotSpot(hotSpot :any) {
    this.hotspotSelected = hotSpot;
  }

  @Emit("next")
  nextFrom(name :string, isDown: boolean = false) {}
}
